import { USER_FORM } from '../form-portaluser-type';
import useAuth from '../../../../hooks/auth-hooks';
import { checkForSelectValue } from '../../form-helpers';
import { getAccessPrevilages, getAndFormatAccessList } from '../form-user-helpers';
import { showToast } from '../../../toasts';

import { wpPostNewUser, awsPostNewUser } from '../../../../routes/post-new-user';

/**
 * Handles formatting the data to send to the api route hanlder for the create new 
 * portal user form.
 * 
 * @returns void
 */
const handleNewPortalUser = () => {
  const { userNew, userStatus, userRole, userName, userFirstName, userLastName, userEmail, userSubmit } = USER_FORM;

  const validateForm = (custPartArray: string) => {
    userNew.classList.add('was-validated');    

    checkForSelectValue(userStatus, 'User Status', 'status');
    checkForSelectValue(userRole, 'User Role', 'role');

    return userNew.checkValidity() &&
        userStatus.getAttribute('data-value') != null &&
        userRole.getAttribute('data-value') != null &&
        custPartArray != '';
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    event.stopPropagation();

    const custPartArray = getAndFormatAccessList();

    if ( validateForm(custPartArray) ) {      
      userNew.classList.remove('was-validated');
      userNew.classList.remove('form-control:valid');
      userSubmit.classList.add('aafp_button-loading');

      try {
        const wpJsonData = {
          newUserName: userName.value,
          newUserFirstName: userFirstName.value,
          newUserLastName: userLastName.value,
          newUserEmail: userName.value,
          newUserStatus: String(userStatus.getAttribute('data-value')),
          newUserRole: String(userRole.getAttribute('data-value'))
        };

        const { wpID } = await wpPostNewUser(wpJsonData);

        const { accessLevel, accessType } = getAccessPrevilages(userRole.getAttribute('data-value')!);
        const { userId } = useAuth()!;

        const awsJsonData = {
          wpId: wpID,
          wpName: `${userFirstName.value} ${userLastName.value}`,
          userEmail: userName.value,
          accessLevel,
          accessType,
          idArray:  custPartArray,
          adminId: userId
        };

        await awsPostNewUser(awsJsonData);
        showToast('aafp_toast', `${userFirstName.value} ${userLastName.value} has been added`);
        setTimeout(() => {
          location.href = '/portal-users/';
        }, 1500);     
      } catch (error) {
        console.error(error);
        showToast('aafp_toast-alert', `Error adding ${userFirstName.value} ${userLastName.value}`);
        userSubmit.classList.remove('aafp_button-loading');
      }
    }
  }

  userNew.addEventListener('submit', handleSubmit);
}

export default handleNewPortalUser;